<template>
  <el-popover trigger="click" placement="right" v-if="rows && rows.length > 0">
    <ul>
      <li v-for="(row, index) in rows" :key="index" @click="onResult(row)">
        <p class="describe">{{ row.Client }}</p>
        <p>
          <el-tag :type="row.State == 0 ? 'danger' : 'primary'" size="mini">
            {{ row.StateText }}
          </el-tag>
          {{ row.Request }}
        </p>
      </li>
    </ul>
    <div class="info" slot="reference">
      <label v-for="row in groupTotal" :key="row.type">
        {{ $utils.meta.format("schedule-type", row.type) }}
        +{{ row.value }}
      </label>
      <label class="text-danger" v-if="rows.filter((t) => t.State == 0).length > 0">待办事项+{{ rows.filter((t) => t.State
    == 0).length }}</label>
    </div>
  </el-popover>
</template>

<script>
import _detail from "./_detail.vue";
export default {
  props: {
    rows: { type: Array, default: null },
  },
  computed: {
    groupTotal() {
      let key = "Type";
      let res = [],
        types = {};
      this.rows
        .filter((t) => t.State == 9)
        .forEach((row) => {
          if (!(row[key] in types)) {
            types[row[key]] = { type: row[key], value: 0 };
            res.push(types[row[key]]);
          }
          types[row[key]].value += 1;
        });
      return res;
    },
  },
  methods: {
    onResult(row) {
      this.$layer.iframe({
        title: "工作任务",
        area: ["600px", "auto"],
        content: {
          content: _detail,
          parent: this,
          data: {
            id: row.Id,
          }
        }
      });
    },
    loadData() {
      this.$emit('loadData');
    }
  },
};
</script>

<style lang="scss" scoped>
ul {
  li {
    list-style: none;
    padding: 10px;
    cursor: pointer;

    p+p {
      margin-top: 10px;
    }
  }
}

.info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  height: 100%;
}
</style>